import { IStockBalance, IStockBalancesListMeta } from '@/models/stockBalances.model';
import { TGetStockBalancesQuery } from '../helpers/types';

export const STOCK_BALANCES_SLICE_NAME = 'stockBalances';

export interface StockBalancesState {
  list: IStockBalance[] | null;
  pagination: IStockBalancesListMeta | null;
  query: TGetStockBalancesQuery | null;
  isLoading: boolean;
  error: unknown;
  activeRequestId: string | null;
}

export const initialState: StockBalancesState = {
  list: null,
  pagination: null,
  query: null,
  isLoading: false,
  error: null,
  activeRequestId: null,
};
